import React, { useMemo, useCallback } from "react";
import { Select, SelectProps } from "@cloudscape-design/components";
import { Realm, Stage, getRealmsForStage } from "../../constants";

interface RealmSelectorProps {
  value: Realm;
  stage: Stage;
  onChange: (realm: Realm) => void;
}

export const RealmSelector: React.FC<RealmSelectorProps> = ({ value, stage, onChange }) => {
  const options = useMemo<SelectProps.Option[]>(() => getRealmsForStage(stage).map((r) => ({ value: r, label: r })), [stage]);

  const selectedOption = useMemo(() => options.find((o) => o.value === value) || null, [options, value]);

  const handleChange = useCallback((e: { detail: SelectProps.ChangeDetail }) => onChange(e.detail.selectedOption.value as Realm), [
    onChange,
  ]);

  return <Select selectedOption={selectedOption} options={options} onChange={handleChange} />;
};
